import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Trophy, Medal } from "lucide-react";
import api from "@/lib/api";

const ORD = (n) => (n === 1 ? "1ª" : `${n}ª`);
const BADGE_INITIAL = { opacity: 0, y: 12 };
const BADGE_ANIMATE = { opacity: 1, y: 0 };
const BADGE_TRANSITION = { delay: 0.2 };
const monthName = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("it-IT", { month: "long" });
};

export function StoreRankBadge({ storeId, contestId, accent }) {
  const [r, setR] = useState(null);
  useEffect(() => {
    if (!storeId) return;
    const load = () => api.storeRank(storeId, contestId).then(setR).catch(() => setR(null));
    load();
    const t = setInterval(load, 3 * 60 * 1000);
    return () => clearInterval(t);
  }, [storeId, contestId]);
  if (!r || !r.plays) return null;

  const first = r.is_first;
  return (
    <motion.div
      initial={BADGE_INITIAL}
      animate={BADGE_ANIMATE}
      transition={BADGE_TRANSITION}
      className="mx-auto mb-6 flex items-center gap-3 rounded-2xl border px-4 py-3 max-w-md text-left backdrop-blur"
      style={{ background: first ? accent || "#f59e0b" : "rgba(255,255,255,0.08)", borderColor: first ? "transparent" : "rgba(255,255,255,0.15)", color: first ? "#0f172a" : "white" }}
      data-testid="store-rank-badge"
      data-rank={r.rank}
    >
      <span className={`grid place-items-center h-11 w-11 rounded-full shrink-0 ${first ? "bg-white/90" : "bg-white/10"}`}>
        {first ? <Trophy className="h-6 w-6 text-amber-500" /> : <Medal className="h-6 w-6" style={{ color: accent }} />}
      </span>
      <div className="leading-tight">
        <p className="font-display font-bold text-sm uppercase tracking-wide">{first ? "Punto vendita del mese" : `${ORD(r.rank)} su ${r.total} sedi a ${monthName(r.month)}`}</p>
        <p className={`text-xs ${first ? "opacity-80" : "text-white/70"}`}>
          {first ? `${r.store_name} · ${r.plays} giocate · ${r.wins} premi vinti` : `${r.store_name} · ${r.plays} giocate · ${r.wins} premi · gioca anche tu e portaci in vetta!`}
        </p>
      </div>
    </motion.div>
  );
}
